import { render, staticRenderFns } from "./FriendSuggestion.vue?vue&type=template&id=2007858d&"
import script from "./FriendSuggestion.vue?vue&type=script&lang=js&"
export * from "./FriendSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports